import { Navigate } from 'react-router-dom'
import { isLoggedIn } from '../../services/authService'

/**
 * Wraps routes that authenticated users should NOT see (login, landing pricing).
 * Redirects them to /love-account instead.
 */
export function PublicRoute({ children }: { children: React.ReactNode }) {
  if (isLoggedIn()) {
    return <Navigate to="/love-account" replace />
  }

  return <>{children}</>
}
